import { useLayoutContext } from 'contexts/LayoutContext';
import FormWrapper from './FormWrapper';
import FeeSettingsForm from './FeeSettingsForm';

const FeeSettings: React.FC = () => {
  const { selectedVehicleId } = useLayoutContext();
  return (
    <FormWrapper vehicleId={selectedVehicleId ?? ''}>
      <FeeSettingsForm />
    </FormWrapper>
  );
};

export default FeeSettings;
